import React from 'react';
import { connect } from 'react-redux';
import CssModules from 'react-css-modules';
import styles from 'application/components/Error.css';

const Error = ({ message }) =>
  <div styleName="container">
    <h1 styleName="header">Oops!</h1>
    <h4 styleName="message">
      {message}
    </h4>
  </div>;

const mapStateToProps = state => ({
  message: state.application.errorMessage,
});

export default connect(mapStateToProps)(CssModules(Error, styles));
